import { render, staticRenderFns } from "./CustomerFlow.vue?vue&type=template&id=2f0b9941&scoped=true"
import script from "./CustomerFlow.vue?vue&type=script&lang=js"
export * from "./CustomerFlow.vue?vue&type=script&lang=js"
import style0 from "./CustomerFlow.vue?vue&type=style&index=0&id=2f0b9941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b9941",
  null
  
)

export default component.exports